<app-header></app-header>
<app-subheader *ngIf="showSubHeader"></app-subheader>
 <div class="container-fluid">
    <router-outlet></router-outlet>
 </div>
<app-footer></app-footer>
<app-loading></app-loading>
